import React from "react";
import { useOutletContext } from "react-router-dom";

interface HandbookOutletContext {
    title: string;
    openEdit?: (row: any) => void;
    canEdit?: boolean;
}

interface Props {
    children: (context: HandbookOutletContext) => React.ReactNode;
}


export const HandbookTableWrapper = ({ children }: Props) => {
    const context = useOutletContext<HandbookOutletContext>();

    return <>{children(context)}</>;
};
